module.exports = __webpack_public_path__ + "fac28f4cad0dc03bdad3054d72d3f2c8.gif";